<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>胜利配置</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <ClearCacheApply />
              <sync-data />
            </el-col>
          </el-row>
        </div>

        <div style="padding: 10px;">
          <el-button type="primary" @click="onSubmit()">保存</el-button>
        </div>
        <div v-for="(winConfigs, betValue) in formData" :key="betValue" class="bet-container">
          <div class="bet-header">
            <span>Bet: {{ betValue }}</span>
            <el-button type="primary" size="mini" @click="showConfigModal(betValue)">+ 配置</el-button>
          </div>
          <div class="bet-config-preview">
            <div v-for="(config, index) in winConfigs" :key="index" class="config-item">
              <span class="config-num">增加值:{{ config.num }}</span>
              <span class="config-pro">概率: {{ config.pro }}%</span>
            </div>
          </div>
        </div>

        <!-- 配置抽屉 -->
        <el-drawer
          :title="`Bet ${currentBetValue} - Win 配置`"
          size="600px"
          :visible.sync="dialogVisible"
          custom-class="slide-from-right-dialog"
          :before-close="handleClose"
        >
          <div v-if="currentBetValue !== null">
            <el-table :data="formData[currentBetValue]" border size="mini">
              <el-table-column label="增加值" width="180">
                <template v-slot:default="drawerScope">
                  <el-input-number v-model="drawerScope.row.num" :min="0" :step="0.01" size="mini" style="width: 100%" placeholder="增加值" />
                </template>
              </el-table-column>
              <el-table-column label="概率(%)" width="180">
                <template v-slot:default="drawerScope">
                  <el-input-number v-model="drawerScope.row.pro" :min="0" :max="100" size="mini" style="width: 100%" placeholder="概率" />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template v-slot:default="drawerScope">
                  <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeWinConfig(currentBetValue, drawerScope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 20px; text-align: left;">
              <el-button type="primary" size="mini" @click="addWinConfig(currentBetValue)">+ 添加配置</el-button>
            </div>
          </div>
        </el-drawer>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg } from '@/api/config/common-cfg'
import { getWinData, updateWinData } from '@/api/config/tetris/win'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'TetrisWin',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      formData: {},
      betConfig: [],
      dialogVisible: false,
      currentBetValue: null
    }
  },
  created() {
    this.initData()
  },
  methods: {
    showConfigModal(betValue) {
      this.currentBetValue = betValue
      this.dialogVisible = true
    },
    handleClose(done) {
      this.dialogVisible = false
      this.currentBetValue = null
      done()
    },
    async initData() {
      try {
        await this.getBetConfig()
        await this.getTables()
      } catch (error) {
        this.msgError('数据初始化失败')
        console.error(error)
      }
    },
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log('提交数据:', data)
      updateWinData({ data })
        .then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
        .catch(error => {
          this.msgError('提交失败')
          console.error(error)
        })
    },
    async getBetConfig() {
      try {
        const res = await getCommonCfg({ name: 'betConfig' })
        this.betConfig = res.data
        console.log('Bet配置:', this.betConfig)
        if (this.betConfig && this.betConfig.normalConfig) {
          this.initializeFormDataFromBetConfig()
        }
      } catch (error) {
        this.msgError('获取Bet配置失败')
        console.error(error)
        throw error
      }
    },
    initializeFormDataFromBetConfig() {
      const normalConfig = this.betConfig.normalConfig
      const existingBets = Object.keys(this.formData)
      normalConfig.forEach(config => {
        const betValue = config.bet || 0
        const betKey = betValue.toString()
        if (!existingBets.includes(betKey)) {
          this.$set(this.formData, betKey, [{ num: 0, pro: 0 }])
        }
      })
    },
    async getTables() {
      try {
        const res = await getWinData()

        if (res.code === 200 && res.data) {
          this.updateFormData(res.data)
          console.log('胜利配置:', this.formData)
        }
      } catch (error) {
        this.msgError('获取胜利配置失败')
        console.error(error)
        throw error
      }
    },
    updateFormData(data) {
      if (typeof data === 'object' && !Array.isArray(data)) {
        Object.entries(data).forEach(([betKey, win_config]) => {
          this.$set(this.formData, betKey, win_config || [{ num: 0, pro: 0 }])
        })
      } else if (Array.isArray(data)) {
        data.forEach(dataItem => {
          const betValue = dataItem.bet || 0
          const betKey = betValue.toString()
          this.$set(this.formData, betKey, dataItem.win_config || [{ num: 0, pro: 0 }])
        })
      }
    },
    addWinConfig(betValue) {
      if (this.formData[betValue]) {
        this.formData[betValue].push({ num: 0, pro: 0 })
      }
    },
    removeWinConfig(betValue, index) {
      if (this.formData[betValue] && this.formData[betValue].length > 1) {
        this.formData[betValue].splice(index, 1)
      }
    }
  }
}
</script>

<style scoped>
.bet-container {
  margin-bottom: 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}

.bet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: #fafafa;
  border-bottom: 1px solid #ebeef5;
}

.bet-header span {
  font-weight: 500;
  font-size: 14px;
}

.bet-config-preview {
  padding: 12px 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  background: #ffffff;
}

.config-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
  font-size: 13px;
}

.config-num {
  color: #67c23a;
  font-weight: 500;
}

.config-pro {
  color: #409eff;
  font-weight: 500;
}
</style>

<style>
/* 弹窗从右侧滑入动画 */
.slide-from-right-dialog {
  animation: slideInFromRight 0.3s ease-out;
}

@keyframes slideInFromRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>

